import { AlertsCard } from '@/features/compliance-alerts/alerts-card';

const OnboardingReviewsPage = () => <AlertsCard alertType="onboarding-alert" />;
OnboardingReviewsPage.displayName = 'OnboardingReviewsPage';

export default OnboardingReviewsPage;
